// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered-popup-backdrop {
    position: fixed;
    height: calc(100vh - var(--menuBarHeight));
    padding: min(3%, 30px) min(4%, 20px);
    width: 100%;
    background-color: #0002;
    z-index: 1000;
    box-sizing: border-box;
    overflow-y: auto;
}

.popup-body-container {
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

@keyframes popupAppear {
    0% {
        transform: scale(1.1);
        opacity: 0.5;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.popup-body {
    background-color: white;
    border-radius: 8px;
    padding: 15px;
    animation: popupAppear 0.2s ease;
    box-sizing: border-box;
    box-shadow: 0px 0px 15px 8px #0003;
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0;
    font-size: 22px;
    font-weight: 800;
    font-family: var(--displayFont);
}
.popup-content {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18px;
    font-family: var(--paragraphFont);
}
.cp-fontsizer {
    font-size: 16px;
}
/* Increase font size a bit on small screens */
@media screen and (max-width: 500px) {
    .popup-header {
        font-size: 26px;
    }
    .popup-content {
        font-size: 20px;
    }
    .hpoup-header-title {
        font-size: 26px;
    }
    .hpopup-content {
        font-size: 20px;
    }
    .cp-fontsizer {
        font-size: 20px;
    }
}

.hpopup-body {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    animation: popupAppear 0.2s ease;
    color: #000;
    box-sizing: border-box;
    box-shadow: 0px 0px 15px 8px #0003;
}

.hpopup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 10px 15px;
    column-gap: 10px;
    border-bottom: 2px solid #0003;
}
.hpopup-header-title {
    font-size: 24px;
    font-weight: 700;
    font-family: var(--displayFont);
}
.hpopup-header-close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    padding: 5px;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    transition: transform 0.2s;
}
.hpopup-header-close-button:hover {
    background-color: #0001;
    cursor: pointer;
}
.hpopup-header-close-icon {
    font-size: 20px;
    height: 25px;
    width: 25px;
    filter: invert(0.5);
}
.hpopup-content {
    overflow-y: auto;
    height: -moz-fit-content;
    height: fit-content;
    padding: 15px;
    font-family: var(--paragraphFont);
    font-weight: 500;
    font-size: 18px;
    box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/CenteredPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,0CAA0C;IAC1C,oCAAoC;IACpC,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,eAAe;AACnB;AACA,8CAA8C;AAC9C;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B","sourcesContent":[".centered-popup-backdrop {\n    position: fixed;\n    height: calc(100vh - var(--menuBarHeight));\n    padding: min(3%, 30px) min(4%, 20px);\n    width: 100%;\n    background-color: #0002;\n    z-index: 1000;\n    box-sizing: border-box;\n    overflow-y: auto;\n}\n\n.popup-body-container {\n    min-height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n@keyframes popupAppear {\n    0% {\n        transform: scale(1.1);\n        opacity: 0.5;\n    }\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.popup-body {\n    background-color: white;\n    border-radius: 8px;\n    padding: 15px;\n    animation: popupAppear 0.2s ease;\n    box-sizing: border-box;\n    box-shadow: 0px 0px 15px 8px #0003;\n}\n\n.popup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    font-size: 22px;\n    font-weight: 800;\n    font-family: var(--displayFont);\n}\n.popup-content {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-family: var(--paragraphFont);\n}\n.cp-fontsizer {\n    font-size: 16px;\n}\n/* Increase font size a bit on small screens */\n@media screen and (max-width: 500px) {\n    .popup-header {\n        font-size: 26px;\n    }\n    .popup-content {\n        font-size: 20px;\n    }\n    .hpoup-header-title {\n        font-size: 26px;\n    }\n    .hpopup-content {\n        font-size: 20px;\n    }\n    .cp-fontsizer {\n        font-size: 20px;\n    }\n}\n\n.hpopup-body {\n    display: flex;\n    flex-direction: column;\n    background-color: white;\n    border-radius: 8px;\n    max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    animation: popupAppear 0.2s ease;\n    color: #000;\n    box-sizing: border-box;\n    box-shadow: 0px 0px 15px 8px #0003;\n}\n\n.hpopup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0;\n    padding: 10px 15px;\n    column-gap: 10px;\n    border-bottom: 2px solid #0003;\n}\n.hpopup-header-title {\n    font-size: 24px;\n    font-weight: 700;\n    font-family: var(--displayFont);\n}\n.hpopup-header-close-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n    height: fit-content;\n    padding: 5px;\n    border-radius: 50%;\n    background-color: transparent;\n    border: none;\n    transition: transform 0.2s;\n}\n.hpopup-header-close-button:hover {\n    background-color: #0001;\n    cursor: pointer;\n}\n.hpopup-header-close-icon {\n    font-size: 20px;\n    height: 25px;\n    width: 25px;\n    filter: invert(0.5);\n}\n.hpopup-content {\n    overflow-y: auto;\n    height: fit-content;\n    padding: 15px;\n    font-family: var(--paragraphFont);\n    font-weight: 500;\n    font-size: 18px;\n    box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
